import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CloButtonGroup, CloButtonGroupOption} from './button-group';

export {CloButtonGroupOption, CloButtonGroup} from './button-group';
@NgModule(
  {
    declarations: [CloButtonGroup, CloButtonGroupOption],
    exports: [CloButtonGroup, CloButtonGroupOption],
    imports: [CommonModule],
    entryComponents: [CloButtonGroup]
  })

export class CloButtonGroupModule {
}
